(window.YPSearch = function ($, Behaviors) {
    "use strict";

    const module = {};


    function YPSearch(elem) {
        Behaviors.init(YPSearch, this, arguments);

        this.$elem.on("click", this.click_intent.bind(this));

    }

    Behaviors.inherit(YPSearch, Behaviors.Behavior);

    YPSearch.QUERY = '[ypsearch-btn]';

    YPSearch.prototype.click_intent = function (e) {
        let {target} = e;
        target = $(target);
        target.toggleClass('active');
        $('.huemorSearch').stop().slideToggle();
    };

    Behaviors.register_behavior(YPSearch);

    module.YPSearch = YPSearch;

    return module;

}(window.jQuery, window.Behaviors));